
import { Folder } from './types';

export const defaultFolders: Folder[] = [
  // --- Level 0: 年級/考試類別 (Roots) ---
  { id: 'grade-private', name: '私中入學考試', parentId: null },
  { id: 'grade-5', name: '國小五年級', parentId: null },
  { id: 'grade-3', name: '國小三年級', parentId: null },

  // --- Level 1: 私中入學 - 科目 ---
  { id: 'subject-math', name: '數學科', parentId: 'grade-private' },
  { id: 'subject-english', name: '英文科', parentId: 'grade-private' },

  // --- Level 2: 私中數學子分類 ---
  { id: 'math-number-theory', name: '數論', parentId: 'subject-math' },
  { id: 'math-patterns', name: '規律', parentId: 'subject-math' },
  { id: 'math-algebra', name: '代數', parentId: 'subject-math' },
  { id: 'math-geometry', name: '幾何', parentId: 'subject-math' },
  { id: 'math-ratio', name: '比與比例', parentId: 'subject-math' },
  { id: 'math-combinatorics', name: '排列組合', parentId: 'subject-math' },

  // --- Level 2: 私中英文子分類 ---
  { id: 'english-grammar', name: '文法與句型', parentId: 'subject-english' },
  { id: 'english-vocab', name: '字彙測驗', parentId: 'subject-english' },

  // --- Level 1: 國小五年級 - 科目 ---
  { id: 'g5-math', name: '數學 (五上)', parentId: 'grade-5' },
  { id: 'g5-math-2', name: '數學 (五下)', parentId: 'grade-5' },
  { id: 'g5-chinese', name: '國語文', parentId: 'grade-5' },

  // --- Level 2: 數學 (五上) 子分類 ---
  { id: 'g5s1-decimals', name: '多位小數與加減', parentId: 'g5-math' },
  { id: 'g5s1-factors', name: '因數｜公因數', parentId: 'g5-math' },
  { id: 'g5s1-multiples', name: '倍數｜公倍數', parentId: 'g5-math' },
  { id: 'g5s1-fraction-reduction', name: '擴分約分通分', parentId: 'g5-math' },
  { id: 'g5s1-polygons', name: '多邊形', parentId: 'g5-math' },
  { id: 'g5s1-sectors', name: '扇形與圓心角', parentId: 'g5-math' },
  { id: 'g5s1-fraction-diff-denom', name: '異分母分數加減', parentId: 'g5-math' },
  { id: 'g5s1-symmetry', name: '線對稱圖形', parentId: 'g5-math' },
  { id: 'g5s1-integer-calc', name: '整數四則計算', parentId: 'g5-math' },
  { id: 'g5s1-area', name: '面積', parentId: 'g5-math' },
  { id: 'g5s1-solids-sphere', name: '柱體錐體和球', parentId: 'g5-math' },
  { id: 'g5s1-cube-rect', name: '正方體和長方體', parentId: 'g5-math' },

  // --- Level 1: 國小三年級 - 科目 (範例) ---
  { id: 'g3-math', name: '數學 (三上)', parentId: 'grade-3' },
  { id: 'g3-life', name: '生活', parentId: 'grade-3' },
];
